module.exports = __webpack_public_path__ + "img/topPic.07227fba.png";